import styled, { css } from 'styled-components';

const PlusAmountWrapper = styled.span`
  display: inline-flex;
  align-items: end;
  gap: 4px;
  ${({ desktopMode, isPickupHeader, theme }) => {
    if (isPickupHeader && !desktopMode) {
      return css`
        ${desktopMode
          ? theme.fontFamily.secondaryFont.smallBold
          : theme.fontFamily.secondaryFont.xSmallBold};
        color: ${theme.colors.night_blue_1};
        div {
          color: ${theme.colors.night_blue_3};
        }
      `;
    }
    return desktopMode
      ? css`
          ${theme.fontFamily.secondaryFont.smallRegular};
          color: ${theme.colors.white};
          line-height: 1;
        `
      : css`
          ${theme.fontFamily.secondaryFont.xSmallBold};
          color: ${theme.colors.night_blue_3};
          margin-top: 2px;
          div {
            color: ${theme.colors.night_blue_3};
          }
        `;
  }}
`;

export default PlusAmountWrapper;
